import React from 'react';
import { cn } from '../../lib/utils'; // or use clsx

export const Button = ({ className = '', children, ...props }: any) => {
  return (
    <button
      className={cn('px-4 py-2 rounded font-medium transition-all', className)}
      {...props}
    >
      {children}
    </button>
  );
};
